module.exports = __webpack_public_path__ + "media/images/pokerroom/partypoker/step3-24ad2fe44e8701b90e673bfc2b1f7fd1.jpg";